// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");

function fromOption(opt, defaultError) {
  if (opt !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_option.valFromOption(opt)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: defaultError
          };
  }
}

function toOption(r) {
  if (r.TAG === /* Ok */0) {
    return Caml_option.some(r._0);
  }
  
}

function mapError(ra, f) {
  if (ra.TAG === /* Ok */0) {
    return ra;
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(f, ra._0)
          };
  }
}

exports.fromOption = fromOption;
exports.toOption = toOption;
exports.mapError = mapError;
/* No side effect */
